import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { some, identity, pick } from 'lodash';

import makeSelectPermissions from '../selectors';

export function useHasPermissionWithValues(permission, itemToCheck) {
  const memoizedSelectPermissionsSelector = useMemo(
    () => makeSelectPermissions(itemToCheck),
    [itemToCheck],
  );
  const CalculatedPermissions = useSelector(memoizedSelectPermissionsSelector);
  const permissionValues = pick(CalculatedPermissions, permission);
  const hasPermission = some(permissionValues, identity);
  return { hasPermission, permissionValues };
}

export default function useHasPermission(permission, itemToCheck) {
  const { hasPermission } = useHasPermissionWithValues(permission, itemToCheck);
  return hasPermission;
}
